define('viewmodels/modals/dialogs/ChooseDepositValuableDialog',[], function () {
    var ChooseDepositValuableDialog = function(dialog, getField) {
        this.dialog = dialog;
        this.title = getField('choose_deposit_valuable_dialog_title');
    };

    ChooseDepositValuableDialog.prototype.close = function() {
        this.dialog.close(this);
    };

    return ChooseDepositValuableDialog;
});

